import { memo } from "react";

/**
 * CardList: プラン・部屋一覧セクションラッパ（見出し + 子カード + 「もっと見る」）
 *
 * ゲスト側 app/frontend/guest/plain/src/components/top/PlanListSection.astro / RoomListSection.astro の
 * 見出し・「もっと見る」ボタンを逐語再現。ボタンは border-b 下線のみで pill 形状ではない。
 */

type Props = {
	title: string;
	hasMore: boolean;
	fontFamilyClassName?: string;
	styleColor?: string;
	children: React.ReactNode;
};

export const CardList = memo(({ title, hasMore, fontFamilyClassName, styleColor, children }: Props) => {
	return (
		<section>
			<h2
				className="mb-5 text-xl font-bold text-zinc-900"
				style={{ fontFamily: fontFamilyClassName, color: styleColor }}
			>
				{title}
			</h2>
			{children}
			{hasMore && (
				<div className="mt-5 text-center tablet:mt-6">
					<button
						type="button"
						className="active-press inline-block border-b border-zinc-900 text-sm font-bold text-zinc-900 tablet:text-base"
					>
						もっと見る
					</button>
				</div>
			)}
		</section>
	);
});

CardList.displayName = "CardList";
